import { render, staticRenderFns } from "./OtnSingleTemplate.vue?vue&type=template&id=7c4847f7&scoped=true&"
import script from "./OtnSingleTemplate.vue?vue&type=script&lang=js&"
export * from "./OtnSingleTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OtnSingleTemplate.vue?vue&type=style&index=0&id=7c4847f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4847f7",
  null
  
)

export default component.exports